import { useQuery } from '@tanstack/react-query';

import { searchFCTransferItems } from 'api/warehouse/fcTransferItems';

export const fcTransferItemsQueryKeys = {
    all: ['fcTransferItems'],
    searchPaginated: (params) => ['fcTransferItems', 'v1', 'search', 'paginated', params],
};

/**
 * Cursor-paginated FC transfer line-item search (merch all-FC stub).
 *
 * @param {Object} [params={}]
 * @param {Object} [options={}]
 * @returns {import('@tanstack/react-query').UseQueryResult<{rows: Array, pagination: Object}, Error>}
 */
export function useFCTransferItemsSearch(params = {}, options = {}) {
    return useQuery({
        queryKey: fcTransferItemsQueryKeys.searchPaginated(params),
        queryFn: async ({ signal }) => {
            const response = await searchFCTransferItems(params, { signal });
            if (!response?.status) {
                throw new Error(response?.msg ?? 'Failed to fetch FC transfer items');
            }
            return response.data ?? { rows: [], pagination: {} };
        },
        staleTime: 30 * 1000,
        ...options,
    });
}
